import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <React.Fragment>
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M13.3681 6.5219C15.1137 7.7129 15.1137 10.2871 13.3681 11.4781L5.19087 17.0576C3.19952 18.4164 0.500001 16.9903 0.500001 14.5795L0.500002 3.42045C0.500002 1.00972 3.19952 -0.416386 5.19087 0.942355L13.3681 6.5219Z"
      fill="inherit"
    />
  </React.Fragment>,
  "ArrowClosedIcon"
);
